import { faBellSlash, faCircle, faMicrophoneSlash, faVideoSlash } from '@fortawesome/pro-duotone-svg-icons';

const proDuotoneSvgIcons = {
  muteDuotone: faMicrophoneSlash,
  recording: faCircle,
  notificationOffDuotone: faBellSlash,
  videoOffDuotone: faVideoSlash,
};

export { proDuotoneSvgIcons };
